export default "__VITE_ASSET__DkpaEplJ__"